/* The Performance stuff is still experimental on node, so shim it for now  */ const performance = typeof window !== 'undefined' ? window.performance : {
    now: ()=>Date.now()
};
export default performance;
